import { requestHandler } from 'lib/api';
import { Dispatch } from 'redux';

export const addMessageToRequest = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/chat/requestType/${data.requestType}/requestId/${data.requestId}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

type GetMessageParams = {
  requestType: string;
  requestId: number;
  lastKeyId?: string;
  lastKeyTimestamp?: string;
};

export const getMessagesFromRequest = async (
  dispatch: Dispatch,
  data: GetMessageParams,
) => {
  const { requestType, requestId, lastKeyId, lastKeyTimestamp } = data;
  const query = `${requestType}/requestId/${requestId}/lastKeyId/${lastKeyId}/lastKeyTimestamp/${lastKeyTimestamp}`;
  const response = await requestHandler({
    method: 'get',
    url: `internal/chat/requestType/${query}`,
    dispatch,
  });
  if (response) return response.data;
};
